

import axios from 'axios'
import * as UAParser from 'ua-parser-js'
import { webLogger } from '../tracing'
import config from '../config'

import {
  AbortSession,
  FetchExperience,
  Login,
  StartSession,
  UpdateTaskLatency,
  UploadImage,
  VerifyProduct,
} from '../types/apis'

const BASE_URL = config.BASE_URL
const N8N_URL = config.N8N_URL
const api = axios.create({
  baseURL: BASE_URL,
})
const apiN8N = axios.create({
  baseURL: N8N_URL,
})
export const login: Login = async (api_key) => {
  try {
    const res = await api.post('/auth/login', {
      api_key,
    })
    const isSuccess = res.status === 200
    if (isSuccess) return res.data
  } catch (err) {
    // Handle error
  }
}

export const fetchExperience: FetchExperience = async (product_scan_id, access_token) => {
  try {
    const res = await api.get(`/fetch-experience?product_scan_id=${product_scan_id}`, {
      headers: { Authorization: `Bearer ${access_token}` },
    })
    const isSuccess = res.status === 200
    if (isSuccess) return res.data
  } catch (err) {
    // Handle error
  }
}

export const startSession: StartSession = async (
  product_config_id,
  access_token,
  geo_location,
  metadata,
) => {
  try {
    const ua = new UAParser.UAParser()
    const deviceDetails = ua.getResult()
    const session_metadata = {
      device_details: deviceDetails,
      cam_list: metadata.camList,
    }
    console.log('BASE_URL', BASE_URL);
    const res = await api.post(
      '/verify/start-session',
      { product_config_id, geo_location, session_metadata },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      },
    )
    const isSuccess = res.status === 200
    if (isSuccess) return res.data
  } catch (err) {
    // Handle error
  }
}

export const uploadImage: UploadImage = async (session_id, formData, access_token) => {
  try {
    const res = await api.post(`verify/upload-image?session_id=${session_id}`, formData, {
      headers: { Authorization: `Bearer ${access_token}` },
    })
    const isSuccess = res.status === 202 && res.data.msg === 'OK' && !!res.data.task_id
    if (isSuccess)
      return {
        status: 'uploaded',
        taskId: res.data.task_id,
      }
  } catch (err: any) {
    const isAlreadyCompleted =
      err.response.status === 400 &&
      err.response.data.msg === 'Session completed and result already generated. Check result.'
    if (isAlreadyCompleted)
      return {
        status: 'completed',
      }

    const isUploadFailed = err.response.status != 202 || err.response.status != 400
    if (isUploadFailed)
      return {
        status: 'failed',
      }
  }
}

export const verifyProduct: VerifyProduct = async (session_id, access_token) => {
  try {
    const res = await api.get(`verify/session-result?session_id=${session_id}`, {
      headers: { Authorization: `Bearer ${access_token}` },
    })
    const isSuccess = res.status === 200
    if (isSuccess) return res.data
  } catch (err) {
    // Handle error
  }
}

export const initiatePoll = async (url, payload, access_token) => {
  try {
    const res = await api.post(
      url,
      payload,
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );

    if (res.status === 200) {
      return res.data;
    }
  } catch (err) {
    console.error('Error in initiatePoll:', err);
    throw err; // Rethrow error for better error handling
  }
};


export const updateTaskLatency: UpdateTaskLatency = async (
  session_id,
  access_token,
  task_id,
  latency_details,
) => {
  try {
    const res = await api.post(
      `verify/update-task-metadata?session_id=${session_id}&task_id=${task_id}`,
      latency_details,
      {
        headers: { Authorization: `Bearer ${access_token}` },
      },
    )
    const isSuccess = res.status === 200
    if (isSuccess) return res.data
  } catch (err) {
    // Handle error
  }
}

export const abortSession: AbortSession = async (
  session_id,
  access_token,
  session_abort_reason,
) => {
  try {
    const res = await api.post(
      `verify/abort-session?session_id=${session_id}&session_abort_reason=${session_abort_reason}`,
      {},
      {
        headers: { Authorization: `Bearer ${access_token}` },
      },
    )
    const isSuccess = res.status === 200
    if (isSuccess) return res.data
  } catch (err) {
    // Handle error
  }
}

export const supportTicket = async (
  sessionId,
  description,
  scanId,
) => {
  try {
    const res = await apiN8N.post(
      '/webhook/support-ticket',
      {
        sessionId,
        description,
        scanId,
      },
    )
    const isSuccess = res.status === 200
    webLogger.info('supportTicketAPICalled', { sessionId, description, scanId })
    if (isSuccess) return res.data
  } catch (err) {
    webLogger.error(`failed to create support Ticket: ${err.message || ''}`, {
      sessionId,
      scanId,
      description,
    })
  }
}
